exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary[data-v-211c93bb]{padding-bottom:1em}.error-display[data-v-211c93bb]{width:100%}.event-right-content[data-v-211c93bb]{right:0;top:0}.app-wrapper[data-v-211c93bb]{position:relative}.module-clash[data-v-211c93bb]{color:red;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-211c93bb","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EventDisplayFull.vue
// module id = 201
// module chunks = 0